var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBnb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#FFAC05"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3226 15.072C12.1445 15.25 11.8558 15.25 11.6777 15.072L9.56484 12.9591C9.38676 12.781 9.09804 12.781 8.91996 12.9591L7.4436 14.4355C7.26553 14.6136 7.26553 14.9023 7.4436 15.0804L11.6777 19.3144C11.8558 19.4925 12.1445 19.4925 12.3226 19.3144L16.5566 15.0804C16.7347 14.9023 16.7347 14.6136 16.5566 14.4355L15.0803 12.9591C14.9022 12.781 14.6135 12.781 14.4354 12.9591L12.3226 15.072Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.193 13.7991C17.3711 13.9772 17.6598 13.9772 17.8379 13.7991L19.3144 12.3226C19.4925 12.1445 19.4925 11.8558 19.3144 11.6777L17.8381 10.2013C17.66 10.0232 17.3713 10.0232 17.1932 10.2013L15.7167 11.6778C15.5386 11.8559 15.5386 12.1446 15.7167 12.3227L17.193 13.7991Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5568 8.92004C16.7349 9.09812 16.7349 9.38685 16.5568 9.56493L15.0803 11.0414C14.9022 11.2195 14.6135 11.2195 14.4354 11.0414L12.3226 8.92861C12.1445 8.75053 11.8558 8.75053 11.6777 8.92861L9.56484 11.0414C9.38676 11.2195 9.09804 11.2195 8.91996 11.0414L7.44344 9.56493C7.26536 9.38685 7.26536 9.09812 7.44344 8.92004L11.6777 4.68581C11.8558 4.50773 12.1445 4.50773 12.3226 4.68581L16.5568 8.92004Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.80704 10.2013C6.62896 10.0232 6.34024 10.0232 6.16216 10.2013L4.68581 11.6777C4.50773 11.8558 4.50773 12.1445 4.68581 12.3226L6.16233 13.7991C6.34041 13.9772 6.62913 13.9772 6.80721 13.7991L8.28356 12.3227C8.46164 12.1446 8.46164 11.8559 8.28356 11.6778L6.80704 10.2013Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3226 13.7992C12.1445 13.9772 11.8558 13.9772 11.6777 13.7992L10.2012 12.3227C10.0232 12.1446 10.0232 11.8559 10.2012 11.6778L11.6777 10.2014C11.8558 10.0233 12.1445 10.0233 12.3226 10.2014L13.799 11.6778C13.9771 11.8559 13.9771 12.1446 13.799 12.3227L12.3226 13.7992Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBnb);
export default __webpack_public_path__ + "static/media/bnb.93c336c77b3419d8afbb0d7f9d10e4cb.svg";
export { ForwardRef as ReactComponent };